import fr from './fr';
import en from './en';
import { Languages, LanguagesManager } from '../../../config/languages';

export interface Definition {
  header1: string;
  header2: string;
  title1: string;
  title2: string;
  title3: string;
  subtitle: string;
  link1: string;
  link2: string;
}

export default new LanguagesManager<Definition>({
  [Languages.FRENCH]: fr,
  [Languages.ENGLISH]: en,
});
